module.exports = __webpack_public_path__ + "static/funded-with-ks-9784e5b3a45fa7db6e7c8b7f13e399f6.png";